import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  url: window._env_.KEYCLOAK_URL,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  realm: window._env_.KEYCLOAK_REALM,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  clientId: window._env_.KEYCLOAK_CLIENT_ID,
});

export default keycloak;
